
export default {
  props: {
    tooltipText: String,

    attach: {
      type: [String, Boolean],
      default: false,
    },

    contentClass: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      isOpen: false,
      timeoutId: null,
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.global.mobile;
    },
  },
};
